<template>
  <div>
    <div>
      <div class="hearter">
        <div>
          <div class="one">
            <p>
              {{ list.title }}
            </p>
          </div>
          <div class="two">
            <p style="color: #999999; font-size: 12px">作者：张某</p>
            <div style="display: flex; align-items: center">
              <img
                style="width: 12px; height: 12px"
                src="../../assets/shu.png"
                alt=""
              />
              <p style="color: #999999; font-size: 12px">{{list.pageview}}阅读</p>
            </div>
            <p style="color: #999999; font-size: 12px">{{list.createTime}}</p>
          </div>
          <div class="imgges">
            <img :src="list.titleUrl" alt="" />
          </div>
          <div class="weizi">
            <p v-html="list.content"></p>
          </div>
        </div>

        <div class="center">
          <div class="title">
            <div class="shu"></div>
            <p style="color: #333333; font-size: 14px; font-weight: normal">
              相关推荐
            </p>
          </div>
          <div class="one_list threemeimei" v-for="item in xialist.slice(0,3)" :key="item.id">
            <div class="box">
              <div class="box-left">
                <div class="left">
                  <img :src="item.titleUrl" alt="" />
                </div>
              </div>
              <div class="box_right">
                <div class="right">
                  <div class="right_top">{{item.title}}</div>
                  <div class="right-botttom vottom">
                    <div style="display: flex; align-items: center">
                      <img src="../../assets/yan.png" alt="" />
                      <p>{{item.pageview}}人观看</p>
                    </div>

                    <div class="button" @click="golettres()">去阅读</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addlistmei } from "../../api/user";
export default {
  data() {
    return {
      id: "",
      list: [],
      xialist: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getdata();
  },
  methods: {
    async getdata() {
      const res = await addlistmei(this.id);
      this.list = res.data;
      this.xialist=res.data.articles
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  .one_list {
    width: 355px;
    height: 100px;
    background: #fefffe;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin: auto;
    margin-top: 10px;
    .box {
      width: 100%;
      height: 100%;
      display: flex;
      .box_right {
        width: 60%;
        height: 100%;
        .right {
          width: 100%;
          height: 100%;
          .vottom {
            display: flex;
            justify-content: space-between;
            padding: 20px 20px;
            box-sizing: border-box;
          }
          .right-botttom {
            width: 100%;
            height: 40%;
            display: flex;
            align-items: center;
            padding: 10px 10px;
            .button {
              width: 68px;
              height: 24px;
              background: linear-gradient(180deg, #4ea3ff 0%, #007aff 100%);
              border-radius: 15px 15px 15px 15px;
              opacity: 1;
              color: #ffffff;
              font-size: 12px;
              text-align: center;
              line-height: 24px;
            }

            img {
              width: 12px;
              height: 12px;
            }
            p {
              color: #999999;
              font-size: 10px;
            }
          }
          .right_top {
            width: 100%;
            height: 60%;
            color: #323332;
            font-size: 14px;
            padding: 10px;
            box-sizing: border-box;
            font-family: PingFang SC-粗体, PingFang SC;
            font-weight: normal;
          }
        }
      }
      .box-left {
        width: 40%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .left {
          width: 95%;
          height: 95%;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .title {
    width: 100%;
    height: 30px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    .shu {
      width: 3px;
      height: 12px;
      background: #007aff;
      border-radius: 212px 212px 212px 212px;
      opacity: 1;
    }
  }
}
.hearter {
  width: 375px;
  height: 96px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  margin: auto;
  margin-top: 10px;
  .weizi {
    width: 353px;
    font-size: 14px;
    font-family: PingFang SC-中等, PingFang SC;
    font-weight: normal;
    color: #777777;
    line-height: 22px;
    margin: auto;
    margin-top: 10px;
  }
  .imgges {
    width: 355px;
    height: 200px;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin: auto;
    img {
      width: 100%;
      height: 100%;
    }
    margin-top: 10px;
  }
  .two {
    width: 100%;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 5px;
  }
  .one {
    width: 100%;
    height: 50%;

    p {
      color: #323332;
      padding: 5px 5px;
      font-size: 16px;
    }
  }
}
</style>